import classNames from "classnames";
import { MouseEventHandler } from "react";
import { Link, To } from "react-router-dom";
import SendIcon from "../../../icons/SendIcon";

type PropTypes = {
  to?: To;
  replace?: boolean;
  onClick?: MouseEventHandler;
  variant?: "white" | "grey";
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "link";
  "data-test-id"?: string;
};

const RoundButton = ({ 
  onClick, 
  to, 
  replace, 
  className, 
  variant = "white",
  type = "button",
  disabled = false,
  "data-test-id": dataTestId,
}: PropTypes) => {
  const Inner = (
    <button
      className={classNames(
        `
        outline-none transition
        flex items-center justify-center w-[50px] h-[50px] rounded-full
        cursor-pointer bg-grey-lightest hover:bg-grey-light
        `,
        {
          "bg-grey-lightest hover:bg-grey-light": variant === "white",
          "bg-pinball hover:bg-grey-lightest": variant === "grey",
          "cursor-default hover:cursor-default opacity-40": disabled,
          "hover:bg-grey-lightest": disabled && variant === "white",
          "hover:bg-pinball": disabled && variant === "grey",
        },
        className,
      )}
      type={type === "link" ? "button" : type}
      onClick={onClick}
      disabled={disabled}
      data-test-id={dataTestId}
    >
      <SendIcon className="w-6 h-6" />
    </button>
  );

  if (to) {
    return (
      <Link to={to} replace={replace} onClick={onClick}>
        {Inner}
      </Link>
    );
  }

  return Inner;
};

export default RoundButton;
